import avatar1 from '../../../../assets/images/xs/avatar1.jpg';
import avatar2 from '../../../../assets/images/xs/avatar2.jpg';
import avatar3 from '../../../../assets/images/xs/avatar3.jpg';
import avatar4 from '../../../../assets/images/xs/avatar4.jpg';
import avatar5 from '../../../../assets/images/xs/avatar5.jpg';
import avatar6 from '../../../../assets/images/xs/avatar6.jpg';
import avatar7 from '../../../../assets/images/xs/avatar7.jpg';

export const roleListcolumns = [
    { Header: 'Id', accessor: 'id'},
    { Header: 'Image', accessor: 'img' },
    { Header: 'User Name', accessor: 'userName' },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Status', accessor: 'status' },
    { Header: 'Action', accessor: 'action' },
  ];

export const roleListTableData = [
    {
        id: '1',
        img: avatar1,
        userName: 'Jone Pit',
        email: 'jone123@gmail.com',
        status: 'Active'
    },
    {
        id: '2',
        img: avatar2,
        userName: 'Jenny Dillow',
        email: 'jennydillow@gmail.com',
        status: 'Active'
    },
    {
        id: '3',
        img: avatar3,
        userName: 'Depo Pillo',
        email: 'depodillow@gmail.com',
        status: 'Active'
    },
    {
        id: '4',
        img: avatar4,
        userName: 'Robert Brown',
        email: 'robert.brown@gmail.com',
        status: 'Active'
    },
    {
        id: '5',
        img: avatar5,
        userName: 'Sarah Johnson',
        email: 'sarah.johnson@gmail.com',
        status: 'Active'
    },
    {
        id: '6',
        img: avatar6,
        userName: 'Michael Smith',
        email: 'michael.smith@gmail.com',
        status: 'Active'
    },
    {
        id: '7',
        img: avatar7,
        userName: 'Emily White',
        email: 'emily.white@gmail.com',
        status: 'Active'
    },
    {
        id: '8',
        img: avatar5,
        userName: 'Christopher Harris',
        email: 'christopher.harris@gmail.com',
        status: 'Active'
    },
    {
        id: '9',
        img: avatar4,
        userName: 'Emma Taylor',
        email: 'emma.taylor@gmail.com',
        status: 'Active'
    },
    {
        id: '10',
        img: avatar2,
        userName: 'David Lee',
        email: 'david.lee@gmail.com',
        status: 'Active'
    },
]